import { Row } from "twyne-new.ui"

import MessageContainer from './MessageContainer'
import TabItem from "./TabItem"
import TabSection from "./TabSection"
import props from './props'

export default function RequestTab({ data, containerMessage }) {
  if (!data) return <MessageContainer message={containerMessage} />
  return <Row>
    <TabItem label="method" value={data.method} />
    <TabItem label="url" value={data.url} sm={12} isBreakWord />
    <TabSection data={data.headers} title="Headers" />
    {data.body && <TabSection data={data.body} title="Body" />}
  </Row>
}

RequestTab.propTypes = props
RequestTab.defaultProps = {}
